/* eslint-disable no-undef,jsx-a11y/control-has-associated-label */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import Calendar from '../../components/Calendar';

const themes = ['light', 'dark'];
const languages = ['en', 'es'];

/**
 * Below functionality is for testing only,
 * swtiching themes and languages will be handled differently
 */
const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

const countryCodes = [
  { value: 'United Kingdom', label: '+44' },
  { value: 'Lebanon', label: '+961' },
  { value: 'USA', label: '+1' },
];

const ShowCase = () => {
  const { t: translate, i18n } = useTranslation();
  const [theme, setTheme] = useState(themes[0]);
  const [language, setLanguage] = useState('en');
  const [searchInput, onChangeSearchInput] = useState('');

  const clearSearchInput = () => onChangeSearchInput('');

  const updateTheme = () => {
    const themeIndex = themes.indexOf(theme);
    const targetTheme = themes[1 - themeIndex];
    setTheme(targetTheme);
    document.querySelector('html').className = `theme-${targetTheme}`;
  };

  const updateLanguage = () => {
    const languageIndex = languages.indexOf(language);
    const targetLanguage = languages[1 - languageIndex];
    setLanguage(targetLanguage);
    i18n.changeLanguage(targetLanguage);
  };

  return (
    <div className="container">
      {/**
       * Buttons
       */}
      <div className="row my-5">
        <div className="col-sm text-center">
          <p>Button primary</p>
          <button className="btn btn-primary btn-lg" onClick={updateTheme} type="button">
            {translate('switch_themes')}
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button outlined</p>
          <button className="btn btn-outline-primary btn-lg" onClick={updateLanguage} type="button">
            {translate('switch_language')}
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button disabled</p>
          <button className="btn btn-disabled btn-lg" onClick={updateLanguage} type="button">
            Disabled
          </button>
        </div>
      </div>
      <div className="row my-5">
        <div className="col-sm text-center">
          <p>Button loading</p>
          <button className="btn btn-primary btn-lg px-5" onClick={updateLanguage} type="button">
            <div className="spinner-border spinner-border-sm" role="status" />
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button loading outlined</p>
          <button
            className="btn btn-outline-primary btn-lg px-5"
            onClick={updateLanguage}
            type="button">
            <div className="spinner-border spinner-border-sm" role="status" />
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button loading disabled</p>
          <button className="btn btn-disabled btn-lg px-5" onClick={updateLanguage} type="button">
            <div className="spinner-border spinner-border-sm" role="status" />
          </button>
        </div>
      </div>
      <div className="row my-5">
        <div className="col-sm text-center">
          <p>Button small</p>
          <button className="btn btn-primary" onClick={updateLanguage} type="button">
            Small
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button small outlined</p>
          <button className="btn btn-outline-primary" onClick={updateLanguage} type="button">
            Small
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button small disabled</p>
          <button className="btn btn-disabled" onClick={updateLanguage} type="button">
            Small
          </button>
        </div>
      </div>
      <div className="row my-5">
        <div className="col-sm text-center">
          <p>Button smaller</p>
          <button className="btn btn-primary btn-sm" onClick={updateLanguage} type="button">
            Smaller
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button smaller outlined</p>
          <button className="btn btn-outline-primary btn-sm" onClick={updateLanguage} type="button">
            Smaller
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button smaller disabled</p>
          <button className="btn btn-disabled btn-sm" onClick={updateLanguage} type="button">
            Smaller
          </button>
        </div>
      </div>
      <div className="row my-5">
        <div className="col-sm text-center">
          <p>Button smaller</p>
          <button className="btn btn-icon-primary" onClick={updateLanguage} type="button">
            <div className="icon icon-deposit-card" />
            Receive
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button disabled</p>
          <button className="btn btn-icon-primary disabled" onClick={updateLanguage} type="button">
            <div className="icon icon-deposit-card" />
            Receive
          </button>
        </div>
        <div className="col-sm text-center">
          <p>Button icon</p>
          <button className="btn btn-primary btn-lg" onClick={updateLanguage} type="button">
            <i className="icon icon-deposit-card" />
            <span>Button</span>
          </button>
        </div>
      </div>

      {/**
             Icons
             */}
      <div className="row my-5">
        <div className="col-sm text-center">
          <p>icon BAL</p>
          <i className="icon-BAL" />
        </div>
        <div className="col-sm text-center">
          <p>icon BCC</p>
          <i className="icon-BCC" />
        </div>
        <div className="col-sm text-center">
          <p>icon BXX</p>
          <i className="icon-BXX" />
        </div>
      </div>

      {/**
       * Inputs
       */}
      <div className="row my-5">
        <div className="col-sm">
          <form>
            <div className="form-group">
              <input type="email" className="form-control-input" placeholder="Email input field" />
              <label className="floating-label">Email address</label>
              <label className="error-label">Invalid email</label>
            </div>
          </form>
        </div>
        <div className="col-sm">
          <form>
            <div className="form-group">
              <input
                type="password"
                className="form-control-input"
                placeholder="Password input with icon"
              />
              <label className="floating-label">Password</label>
              <label className="error-label">Weak passowrd</label>
              <span className="icon icon-open-icon h4" />
            </div>
          </form>
        </div>
        <div className="col-sm">
          <form>
            <div className="form-group">
              <input className="form-control-input" placeholder="Disabled input" disabled />
              <label className="floating-label">Username</label>
            </div>
          </form>
        </div>
      </div>

      {/**
       * Dropdown
       */}
      <div className="row my-5">
        <div className="select-group col-sm-4">
          <Select
            placeholder="Country"
            className="react-select-container"
            classNamePrefix="react-select"
            options={options}
          />
        </div>
        <div className="col-sm-4">
          <div className="select-group d-flex flex-row">
            <Select
              placeholder={translate('phone_number_country_code')}
              className="react-select-container small"
              classNamePrefix="react-select"
              options={countryCodes}
            />
            <div className="form-group w-75">
              <input type="email" className="form-control-input" placeholder="Phone number" />
              <label className="floating-label">Phone number</label>
              <label className="error-label">Invalid number</label>
            </div>
          </div>
        </div>
        {/**
         * Search input
         */}
        <div className="col-sm-4">
          <div className="form-group">
            <input
              value={searchInput}
              onChange={(e) => onChangeSearchInput(e.target.value)}
              name="search"
              className="form-control-search"
              placeholder="Search wallet"
            />
            <span
              className="icon icon-close-other text-shadow"
              onClick={clearSearchInput}
              onKeyDown={clearSearchInput}
              role="button"
              aria-label="Clear search"
              tabIndex={0}
            />
            <span className="icon-search icon-search-other text-shadow" />
          </div>
        </div>
      </div>

      {/*
       * Typography
       */}
      <div className="row my-5">
        <div className="col-sm-7">
          <h1 className="text-primary">Desktop/IFrame typography (Headline1)</h1>
          <h2 className="text-dark">Desktop/IFrame typography (Headline 2)</h2>
          <h3 className="text-shadow">Desktop/IFrame typography (Headline 3)</h3>
        </div>

        <div className="col-sm-5">
          <p className="text-primary headline1">Desktop/IFrame typography (Paragraph 1)</p>
          <p className="text-dark headline2">Desktop/IFrame typography (Paragraph 2)</p>
          <p className="text-shadow headline3">Desktop/IFrame typography (Paragraph 3)</p>
        </div>
      </div>

      {/**
       * Alerts
       */}
      <div className="row my-5">
        <div className="col-sm">
          <div className="alert alert-info" role="alert">
            <i className="icon icon-info-icon" />
            <span className="content">
              Heads up! This alert needs your attention, but it’s not super important.
            </span>
          </div>
        </div>
        <div className="col-sm">
          <div className="alert alert-warning" role="alert">
            <i className="icon icon-attention-other" />
            <span className="content">
              Warning! Better check yourself, you’re not looking too good.
            </span>
          </div>
        </div>
        <div className="col-sm">
          <div className="alert alert-danger" role="alert">
            <i className="icon icon-cancel-icon" />
            <span className="content">
              Oh snap! Change a few things up and try submitting again.
            </span>
          </div>
        </div>
      </div>
      <div className="row my-5">
        <div className="col-sm">
          <div className="col-sm">
            <div className="alert alert-success" role="alert">
              <i className="icon icon-cancel-icon" />
              <span className="content">
                Oh snap! Change a few things up and try submitting again.
              </span>
            </div>
          </div>
        </div>
        <div className="col-sm">
          <div className="col-sm">
            <div className="alert alert-success alert-action" role="alert">
              <i className="icon icon-cancel-icon" />
              <span className="content">
                Oh snap! Change a few things up and try submitting again.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="row my-5">
        <div className="col-sm">
          <div className="alert alert-info alert-action" role="alert">
            <i className="icon icon-info-icon" />
            <span className="content">
              Heads up! This alert needs your attention, but it’s not super important.
            </span>
            <i className="icon icon-arrow-next-navigation" />
          </div>
        </div>
        <div className="col-sm">
          <div className="alert alert-warning alert-action" role="alert">
            <i className="icon icon-attention-other" />
            <span className="content">
              Warning! Better check yourself, you’re not looking too good.
            </span>
            <i className="icon icon-arrow-next-navigation" />
          </div>
        </div>
        <div className="col-sm">
          <div className="alert alert-danger alert-action" role="alert">
            <i className="icon icon-cancel-icon" />
            <span className="content">
              Oh snap! Change a few things up and try submitting again.
            </span>
            <i className="icon icon-arrow-next-navigation" />
          </div>
        </div>
      </div>
      <Calendar isVisible={false} onSubmit={(date) => alert(JSON.stringify(date))} />
    </div>
  );
};

export default ShowCase;
